(function () {
  const prefetched = new Set();

  function prefetch(url) {
    if (!url || prefetched.has(url)) return;
    prefetched.add(url);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }

  document.addEventListener('mouseover', function (e) {
    // Product cards
    const cardLink = e.target.closest('.product-card__link');
    if (cardLink && cardLink.href) {
      prefetch(cardLink.href);
      return;
    }

    // Variant swatches
    const label = e.target.closest('.variant-option__button-label');
    if (!label) return;
    const input = label.querySelector('input[data-variant-id]');
    if (!input) return;
    const picker = label.closest('variant-picker');
    if (!picker) return;
    const productUrl = picker.dataset.productUrl;
    const variantId = input.dataset.variantId;
    if (productUrl && variantId) {
      prefetch(productUrl + '?variant=' + variantId);
    }
  });
})();
